window.addEventListener('load', () => {
    const accordionPanels = document.querySelectorAll('.accordion-panel');
    if (accordionPanels.length) {
        for (let accordion of accordionPanels) {
            const accordionBtns = accordion.querySelectorAll('.accordion-trigger');

            for (let btn of accordionBtns) {
                let btnAccordionContent = btn.querySelector('.accordion-content');
                let accAccordionContent = accordion.querySelector('.accordion-content');
                let closeButton = accordion.querySelector('.close-button');

                if (closeButton) {
                    closeButton.addEventListener('click', () => {
                        if (btnAccordionContent) {
                            if (btnAccordionContent.classList.contains('hidden')) {
                                showAccordionDetails(btn)
                            }
                            else {
                                hideAccordionDetails(btn)
                            }
                        }
                        else {
                            if (accAccordionContent.classList.contains('hidden')) {
                                showAccordionDetails(accordion)
                            }
                            else {
                                hideAccordionDetails(accordion)
                            }
                        }
                    });
                }

                // Compares mousedown to mouseup time, if less then 200ms or mouseup on an anchor element does not fire
                // (allows for highlight selection of text within accordion & clicking anchors without toggling state)
                let mousedownDateTime;
                btn.addEventListener('mousedown', () => {
                    mousedownDateTime = Date.now();
                });
                btn.addEventListener('mouseup', event => {
                    let timeSinceMouseDown = Date.now() - mousedownDateTime;
                    if (timeSinceMouseDown <= 200 && !(event.target instanceof HTMLAnchorElement)) {
                        if (btnAccordionContent) {
                            if (btnAccordionContent.classList.contains('hidden')) {
                                showAccordionDetails(btn)
                            } else {
                                hideAccordionDetails(btn)
                            }
                        } else {
                            if (accAccordionContent.classList.contains('hidden')) {
                                showAccordionDetails(accordion)
                            } else {
                                hideAccordionDetails(accordion)
                            }
                        }
                    }
                });

                // Allows accordions to be opened / closed via 'enter' key press when focused
                btn.addEventListener("keydown", (e) => {
                    if (document.activeElement === btn) {
                        if (e.key === "Enter") {
                            if (btnAccordionContent) {
                                if (btnAccordionContent.classList.contains('hidden')) {
                                    showAccordionDetails(btn)
                                } else {
                                    hideAccordionDetails(btn)
                                }
                            } else {
                                if (accAccordionContent.classList.contains('hidden')) {
                                    showAccordionDetails(accordion)
                                } else {
                                    hideAccordionDetails(accordion)
                                }
                            }
                        }
                    }
                });
            }
        }
    }

    function classToggles(element) {
        let accordionContent = element.querySelector('.accordion-content');
        let crossOne = element.querySelector('.cross-p-1');
        let crossTwo = element.querySelector('.cross-p-2');
        let caretOne = element.querySelector('.caret-p-1');
        if (accordionContent) {
            accordionContent.classList.toggle('!max-h-[0]');
            accordionContent.classList.toggle('opacity-0');
        }
        if (crossOne && crossTwo) {
            crossOne.classList.toggle('rotate-180');
            crossTwo.classList.toggle('opacity-0');
            crossTwo.classList.toggle('rotate-90');
        }
        if (caretOne) {
            caretOne.classList.toggle('-rotate-90');
        }
    }

    function showAccordionDetails(element) {
        if (element.querySelector('.accordion-content')) {
            element.querySelector('.accordion-content').classList.toggle('hidden');
        }
        setTimeout(() => {
            classToggles(element);
        }, 50);
    }

    function hideAccordionDetails(element) {
        classToggles(element);
        setTimeout(() => {
            if (element.querySelector('.accordion-content')) {
                element.querySelector('.accordion-content').classList.toggle('hidden');
            }
        }, 300);
    }
})